import { Slide } from '@mui/material';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import IssueDrawer from '../../common/components/IssueDrawer/IssueDrawer';
import {
  closeIssueModal,
  setLastDrawerHeight,
} from '../store-actions/pipeline-issues-store-actions';
import {
  setExcludeIssueModal,
  setIsExcludeDedault,
} from '../../common/store-actions/issues-exclusions-store-actions';
import PipelineIssuesStore from '../stores/pipeline-issues-store';
import { IssueAction } from '../../common/types/issues-types';
import { FaFlag } from 'react-icons/fa';
import { MdAccessTimeFilled } from 'react-icons/md';
import { ReactComponent as ExclusionsIcon } from '../../../assets/icons/exclusions-small.svg';
import PipelineIssueCard from '../components/PipelineIssueCard';

const PipelineIssueDrawerContainer: FC<
  React.PropsWithChildren<PipelineIssueDrawerContainerProps>
> = ({ className }) => {
  const { selectedIssue, loadingIssue, lastDrawerHeight } =
    useSnapshot(PipelineIssuesStore);

  const handleExcludeIssue = () => {
    setIsExcludeDedault(true);
    setExcludeIssueModal(true);
  };

  const actions: IssueAction[][] = [
    [
      {
        text: selectedIssue?.excludedByAlert
          ? 'The issue is already excluded'
          : 'Exclude Issue',
        icon: ExclusionsIcon,
        onClick: handleExcludeIssue,
        disabled: selectedIssue?.excludedByAlert,
        highlight: false,
      },
      {
        text: 'Snooze Issue',
        icon: MdAccessTimeFilled,
        onClick: handleExcludeIssue,
        disabled: selectedIssue?.excludedByAlert,
        highlight: false,
      },
      {
        text: 'Report As False-Positive',
        icon: FaFlag,
        onClick: () => {},
        highlight: false,
      },
    ],
  ];

  if (!selectedIssue) {
    return null;
  }

  return (
    <IssueDrawer
      className={className}
      title={selectedIssue.mainTitle}
      onClose={closeIssueModal}
      loading={loadingIssue}
      defaultHeight={lastDrawerHeight}
      isExclude={selectedIssue.excludedByAlert}
      onResizeStop={setLastDrawerHeight}
      actions={actions}
      issueId={selectedIssue.id}>
      <Slide direction='up' in>
        <div>
          <PipelineIssueCard actions={actions} issueDetails={selectedIssue} />
        </div>
      </Slide>
    </IssueDrawer>
  );
};

interface PipelineIssueDrawerContainerProps {
  className: string;
}

export default PipelineIssueDrawerContainer;
